var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-number-widget"},[_c('input',{attrs:{"type":"number","placeholder":_vm.placeholder,"max":_vm.max,"min":_vm.min},domProps:{"value":_vm.value},on:{"keyup":_vm.onNumberKeyup,"change":_vm.onNumberChange,"keydown":_vm.onNumberKeydown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }